import { Column, Index, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MSfpSmartFilterGroupEntity } from './m-sfp-smart-filter-group.entity';
import { MSfpSmartFilterRbacRoleEntity } from './m-sfp-smart-filter-rbac-role.entity';
import { MSfpWorkdComponentEntity } from './m-sfp-workd-component.entity';

@Index('fk_m_sfp_smart_filter_group__id', ['fkMSfpSmartFilterGroupId'], {})
@Index('fk_m_sfp_workd_component__id', ['fkMSfpWorkdComponentId'], {})
@Entity('m_sfp_smart_filter', {}, { label: 'Smart Filter' })
export class MSfpSmartFilterEntity extends BaseEntity {
	@Column('int', {
		name: 'fk_m_sfp_smart_filter_group__id',
		nullable: true,
		unsigned: true,
	})
	public fkMSfpSmartFilterGroupId!: number | null;

	@Column('int', { name: 'fk_m_sfp_workd_component__id', unsigned: true })
	public fkMSfpWorkdComponentId!: number;

	@Column('longtext', { name: 'workdComponentInput' })
	public workdComponentInput!: string;

	@Column('varchar', { name: 'label', length: 64 })
	public label!: string;

	@Column('varchar', { name: 'key', length: 64 })
	public key!: string;

	@Column('varchar', { name: 'icon', length: 64 })
	public icon!: string;

	@Column('longtext', { name: 'countQuery' })
	public countQuery!: string;

	@Column('varchar', { name: 'pathToResult', length: 255 })
	public pathToResult!: string;

	@Column('text', { name: 'description', nullable: true })
	public description!: string | null;

	@Column('longtext', { name: 'stateRanges', nullable: true })
	public stateRanges!: string | null;

	@Column('varchar', { name: 'm_sm_feature', nullable: true, length: 64 })
	public mSmFeature!: string | null;

	@Column('varchar', { name: 'pathToMediumAlert', nullable: true, length: 255 })
	public pathToMediumAlert!: string | null;

	@Column('varchar', { name: 'pathToHighAlert', nullable: true, length: 255 })
	public pathToHighAlert!: string | null;

	@ManyToOne(
		() => MSfpWorkdComponentEntity,
		(mSfpWorkdComponent) => mSfpWorkdComponent.mSfpSmartFilters,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: 'fk_m_sfp_workd_component__id', referencedColumnName: 'id' },
	])
	public fkMSfpWorkdComponent!: MSfpWorkdComponentEntity;

	@ManyToOne(
		() => MSfpSmartFilterGroupEntity,
		(mSfpSmartFilterGroup) => mSfpSmartFilterGroup.mSfpSmartFilters,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: 'fk_m_sfp_smart_filter_group__id', referencedColumnName: 'id' },
	])
	public fkMSfpSmartFilterGroup!: MSfpSmartFilterGroupEntity;

	@OneToMany(
		() => MSfpSmartFilterRbacRoleEntity,
		(mSfpSmartFilterRbacRole) => mSfpSmartFilterRbacRole.fkMSfpSmartFilter,
		{},
	)
	public mSfpSmartFilterRbacRoles!: Array<MSfpSmartFilterRbacRoleEntity>;
}
